import React from 'react';

import * as styles from './Grid.module.scss';
import { defaultXl, defaultLg, defaultMd, defaultSm, defaultXsm } from './constants';

export default function Grid({
  xsm = {},
  sm = {},
  md = {},
  lg = {},
  xl = {},
  gutterX,
  gutterY,
  children,
}) {
  const style = {
    '--columnsXl': xl.cols ?? defaultXl.cols,
    '--columnsLg': lg.cols ?? defaultXl.cols,
    '--columnsMd': md.cols ?? defaultMd.cols,
    '--columnsSm': sm.cols ?? defaultSm.cols,
    '--columnsXsm': xsm.cols ?? defaultXsm.cols,
    '--gutterX-xl': xl.gutterX ?? gutterX ?? defaultXl.gutterX,
    '--gutterX-lg': lg.gutterX ?? gutterX ?? defaultLg.gutterX,
    '--gutterX-md': md.gutterX ?? gutterX ?? defaultMd.gutterX,
    '--gutterX-sm': sm.gutterX ?? gutterX ?? defaultSm.gutterX,
    '--gutterX-xsm': xsm.gutterX ?? defaultXsm.gutterX ?? gutterX,
    '--gutterY-xl': xl.gutterY ?? gutterY ?? defaultXl.gutterY,
    '--gutterY-lg': lg.gutterY ?? gutterY ?? defaultLg.gutterY,
    '--gutterY-md': md.gutterY ?? gutterY ?? defaultMd.gutterY,
    '--gutterY-sm': sm.gutterY ?? gutterY ?? defaultSm.gutterY,
    '--gutterY-xsm': xsm.gutterY ?? gutterY ?? defaultXsm.gutterY,
  };

  return (
    <div className={styles.grid} style={style}>
      {children}
    </div>
  );
}
